import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/11.jpeg";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";

export const PersonBakytkereiuly = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}>Бақыткерейұлы Батырбек</MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Bachelor of Information Technologies, Master student of Computer Science and Engineering
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={"https://orcid.org/0009-0008-6716-2457"}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                        <Link target={"_blank"} to={"https://www.scopus.com/authid/detail.uri?authorId=59308762300"}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}>Основное место работы, должность</MyText>
                    <MyText>ТОО «Astana IT University», специалист департамента ЦКС.<br /><i>Стаж — 2 года.</i></MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте</MyText>
                <MyText size={"small"} italic>Разработчик ГИС / Backend-разработчик</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка IoT-устройств и систем сбора данных;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Создание моделей облачной архитектуры (микросервисы);
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Разработка API и сервисов визуализации данных.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR21882258 «Экологический мониторинг эмиссий» — исполнитель.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - BR24993128 «ИАС трансграничных водных ресурсов» — исполнитель.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Публикации:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    1. Toxanov, Bakytkereiuly, Neftissov. Development of a database for stationary pollution sources. IEEE SIST 2024.
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    2. Toxanov et al. Analysis of blockchain sharding impact. Scientific Journal of AITU, 2024.
                </MyText>
            </Flex>
        </Flex>
    );
};
